/**
 * @file customer-info.ts
 * @description Шапка и показатели карточки клиента (phase19.31, SC63).
 *
 *  - подпись под именем: «+7 981 750-55-00 · почта · клиент с 14.08.2026»;
 *  - четыре компактные плитки (уточнение владельца 2026-10-02 «так же не
 *    видна информация» — строка текста на фоне терялась): «Сумма покупок»
 *    (вместо LTV) «по оплаченным», «Заказов» «оплачено N», «Средний чек»,
 *    «Последний заказ» «10 дней назад». Суммы без нулевых копеек.
 * Сводки нет (сервер не ответил) — значения прочерком, карточка работает.
 */

import type { CustomerDto, CustomerStatsDto } from "../../../lib/api-customers";
import { daysAgoText } from "../../../lib/crm-customer-view";
import { formatRub } from "../../../lib/crm-deal-view";
import { formatPhone } from "../../../lib/phone-format";
import { formatShopDate } from "../../../lib/shop-time";

export function customerSubtitle(c: Pick<CustomerDto, "phone" | "email" | "createdAt">): string {
  return [c.phone ? formatPhone(c.phone) : null, c.email, `клиент с ${formatShopDate(c.createdAt)}`]
    .filter(Boolean)
    .join(" · ");
}

/** Плитка показателя: подпись, значение, пояснение. */
export interface CustomerMetric {
  key: string;
  label: string;
  value: string;
  hint?: string;
}

export function buildCustomerMetrics(stats: CustomerStatsDto | null): CustomerMetric[] {
  if (!stats) {
    return [
      { key: "ltv", label: "Сумма покупок", value: "—", hint: "по оплаченным" },
      { key: "orders", label: "Заказов", value: "—" },
      { key: "avg", label: "Средний чек", value: "—" },
      { key: "last", label: "Последний заказ", value: "—" },
    ];
  }
  const cancelled = stats.ordersCancelled > 0 ? `, отменено ${stats.ordersCancelled}` : "";
  return [
    { key: "ltv", label: "Сумма покупок", value: formatRub(stats.ltvPaid, "whole"), hint: "по оплаченным" },
    { key: "orders", label: "Заказов", value: String(stats.ordersTotal), hint: `оплачено ${stats.ordersPaid}${cancelled}` },
    { key: "avg", label: "Средний чек", value: stats.ordersPaid > 0 ? formatRub(stats.avgOrderValue, "whole") : "—" },
    stats.lastOrderAt
      ? { key: "last", label: "Последний заказ", value: formatShopDate(stats.lastOrderAt), hint: daysAgoText(stats.lastOrderAt) }
      : { key: "last", label: "Последний заказ", value: "—", hint: "заказов ещё не было" },
  ];
}
